import { BUCKET_MANAGEMENT } from '../constants/EntityName';
import { customErrorMsg, errorMsg } from '../constants/messages';
import { REGEX_PASSWORD, REGEX_PHONE_NUMBER } from '../utils/Regexp/Regex';
import { getOptions } from './OptionService';

type RolesType = { id: string; value: string; name: string }[];

export const rolesOption: RolesType = [
  { id: '1', value: 'Super Admin', name: 'Super Admin' },
  { id: '2', value: 'Ops Executive', name: 'Ops Executive' },
  { id: '3', value: 'Ops Manager', name: 'Ops Manager' },
  { id: '4', value: 'Accountant', name: 'Accountant' },
  { id: '5', value: 'Content Manager', name: 'Content Manager' },
];

const usersFormData = [
  {
    title: 'User Details',
    name: 'employeeId',
    label: 'Employee ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Employee ID',
      enableSort: true,
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    readonly: true,
    hideFromUserFormGrid: true,
  },
  {
    name: 'name',
    label: 'Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Name', enableSort: true, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'email',
    label: 'E-mail',
    fieldType: {
      name: 'email',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'E-mail', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'password',
    label: 'Password',
    fieldType: {
      name: 'text',
    },
    required: true,
    rules: [
      {
        pattern: REGEX_PASSWORD,
        message:
          'Password must contain uppercase character, lowercase character, symbol, and number and of length 8',
      },
    ],
    errorMsg: errorMsg,
    tableMeta: { title: 'Password', columnType: 'password' },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    readonly: false,
  },
  {
    name: 'createdAt',
    label: 'Country Code',
    fieldType: {
      name: 'select',
      options: [],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Country Code', allowAddRecordClick: false },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    hideFromUserFormGrid: true,
  },
  {
    name: 'phone',
    label: 'Phone No',
    fieldType: {
      name: 'text',
    },
    required: true,
    rules: [{ pattern: REGEX_PHONE_NUMBER, message: customErrorMsg('phone number') }],
    errorMsg: errorMsg,
    tableMeta: { title: 'Contact', allowAddRecordClick: false, columnType: 'phoneWithCountry' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    inlineCountryCodeField: 'createdAt',
  },
  {
    name: 'role',
    label: 'Role',
    fieldType: {
      name: 'rolePermissions',
      options: rolesOption,
    },
    placeholder: 'Click here to select an item',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Role',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'roleName',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    readonly: false,
  },

  {
    name: 'isActive',
    label: 'Is Active',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Active', value: 'Active' },
        { label: 'Inactive', value: 'Inactive' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Is Active',
      enableSort: false,
      columnType: 'checkbox',
    },
    isTableHeader: true,
    isAccordian: true,
    default: 'Active',
  },
  {
    name: 'bucket',
    label: 'Bucket',
    fieldType: {
      name: 'multiSelect',
      options: [],
      disabledCondition: (formValues: any) =>
        ['Super Admin', 'Accountant', 'Content Manager', 'Content Management'].includes(
          formValues.role
        ),
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Bucket',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'bucket',
    },
    isTableHeader: true,
    isAccordian: true,
    default: [],
    readonly: false,
    transform: {
      in: (value: any) => (Array.isArray(value) ? value : []),
      out: (value: any) => (Array.isArray(value) ? value : []),
    },
  },
];

//eslint-disable-next-line
const fetchAndSetOptions = async () => {
  try {
    // Fetch only active buckets for admin users
    const options = await getOptions(`${BUCKET_MANAGEMENT}?activeOnly=true`);
    const tempArr = options.map((item: any) => ({
      name: item.title,
      value: item.title,
      id: item.id,
      label: item.title,
    }));

    if (tempArr.length > 0 && usersFormData) {
      usersFormData.forEach((item: any) => {
        if (item.name === 'bucket') {
          item.fieldType.options = tempArr;
        }
      });
    }
  } catch (error) {
    console.error('Error setting options:', error);
  }
};

export { usersFormData, fetchAndSetOptions };
